import { render } from "./tableComp.vue?vue&type=template&id=681c8dcc"
import script from "./tableComp.vue?vue&type=script&lang=js"
export * from "./tableComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__